import { ApButtonDanger } from '@alixpartners/ui-components';
import { PERMISSIONS, PermissionsContext } from 'contexts/PermissionsContext';
import React from 'react';
import {
	BottomSection,
	Content,
	Description,
	Section,
	Sidebar,
	Title,
	Wrapper,
} from './AppendCategoryData.styles';
import { deleteCategoryData } from 'utils/apiRequests';
import { useState } from 'react';
import CategoryData from './CategoryData/CategoryData';
import DeleteAllVendorDataModal from 'Data/components/DeleteVendorDataModal';
import { CategoryFileArchiveContext } from 'contexts/CategoryFileArchiveContext';
import { UploadCategoryStateContext } from 'contexts/UploadCategoryStateContext';
import { CategoryFileArchiveContextProvider } from 'contexts/CategoryFileArchiveContext/CategoryFileArchiveContextProvider';

const AppendCategoryData = ({
	permissions,
	status,
	fetchFileArchive,
	setCurrentContent,
}) => {
	const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);
	const canDeleteAllData = permissions.includes(
		PERMISSIONS.TransactionsDeleteAll
	);

	const handleDeleteAllData = () => {
		setIsDeleting(true);
		deleteCategoryData()
			.then(response => {
				if (response.statusCode === 200) {
					setIsDeleting(false);
					setDeleteModalOpen(false);
					fetchFileArchive();
				}
			})
			.catch(() => {
				setIsDeleting(false);
			});
	};

	return (
		<>
			<Wrapper>
				<Sidebar>
					<Section>
						<Title>Data upload</Title>
						<Description>
							<p>Data upload process:</p>
							<p>1. Upload file into the system</p>
							<p>2. Get Dashboard Populated</p>
						</Description>
					</Section>
					{canDeleteAllData && (
						<BottomSection>
							<Title>Delete data</Title>
							<Description>Data deletion clears Dashboard tables</Description>
							<ApButtonDanger
								iconName="delete"
								onClick={e => {
									e.preventDefault();
									setDeleteModalOpen(true);
								}}
							>
								Delete all data
							</ApButtonDanger>
						</BottomSection>
					)}
				</Sidebar>
				<Content>
					<CategoryData status={status} />
				</Content>
				{canDeleteAllData &&
					isDeleteModalOpen && (
						<DeleteAllVendorDataModal
							onConfirm={handleDeleteAllData}
							onCancel={() => (!isDeleting ? setDeleteModalOpen(false) : null)}
							inProgress={isDeleting}
						/>
					)}
			</Wrapper>
		</>
	);
};

export default props => (
	<CategoryFileArchiveContextProvider>
		<CategoryFileArchiveContext.Consumer>
			{({ fileArchive, refetch }) => (
				<UploadCategoryStateContext.Consumer>
					{({ categoryStatus }) => (
						<PermissionsContext.Consumer>
							{({ permissions }) => (
								<AppendCategoryData
									{...props}
									permissions={permissions || []}
									status={categoryStatus}
									fileArchive={fileArchive}
									fetchFileArchive={refetch}
								/>
							)}
						</PermissionsContext.Consumer>
					)}
				</UploadCategoryStateContext.Consumer>
			)}
		</CategoryFileArchiveContext.Consumer>
	</CategoryFileArchiveContextProvider>
);
